import { useSubscription } from '@apollo/client';
import { Fragment } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import {
  LiveLotFeedDocument,
  LiveLotFeedSubscription,
  useMeQuery,
  useMyLotsQuery,
} from '../../graphql/types';
import { Alert, AlertVariant } from '../alert/alert';
import { Button } from '../button/button';

export function Toasts() {
  const params = useParams();
  const me = useMeQuery({
    fetchPolicy: 'cache-first',
  });
  const paddleId = me.data?.me?.paddle?.id;
  const lots = useMyLotsQuery({
    variables: { filter: { paddleId }, first: 100 },
    skip: !paddleId,
    fetchPolicy: 'network-only',
  });
  const lotIds = lots.data?.allLots.edges.map((edge) => edge.node.id) ?? [];

  useSubscription<LiveLotFeedSubscription>(LiveLotFeedDocument, {
    variables: { lotIds },
    skip: !lotIds.length,
    onSubscriptionData({ subscriptionData }) {
      if (subscriptionData.data?.liveLotFeed?.lot?.id === params?.lotId) {
        return;
      }
      toast("You've been outbid! Place a bid to stay on the leaderboard.");
    },
  });

  return (
    <Fragment>
      <Toaster containerStyle={{ inset: 0 }} toastOptions={{ duration: 6000 }}>
        {(t) => (
          <div
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                toast.dismiss(t.id);
              }
            }}
            role="button"
            tabIndex={0}
            onClick={() => {
              toast.dismiss(t.id);
            }}
          >
            <Alert
              style={{
                opacity: t.visible ? 1 : 0,
              }}
              copy="You've been outbid! Place a bid to stay on the leaderboard."
              variant={AlertVariant.Warning}
              action={<Button size="sm">Go to My Lots</Button>}
            />
          </div>
        )}
      </Toaster>
    </Fragment>
  );
}
